/**
 * @packageDocumentation
 * @module StockChartModule Main Module
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StockChartRoutingModule } from './stock-chart-routing.module';
import { StockChartComponent } from './stock-chart/stock-chart.component';
import { StockChartFilterComponent } from './stock-chart-filter/stock-chart-filter.component';
import { StockChartDateHandlerComponent } from './stock-chart-date-handler/stock-chart-date-handler.component';
import { StockChartRendererComponent } from './stock-chart-renderer/stock-chart-renderer.component';
import { SmaModelComponent } from './sma-model/sma-model.component';
import { StockChartSharedModule } from './stock-chart-shared/stock-chart-shared.module';

@NgModule({
  declarations: [StockChartComponent, StockChartFilterComponent, StockChartDateHandlerComponent, StockChartRendererComponent, SmaModelComponent],
  imports: [
    CommonModule,
    StockChartRoutingModule,
    // SharedModule,
    StockChartSharedModule,
  ],
  exports: [StockChartComponent],
  entryComponents: [SmaModelComponent]
})
export class StockChartModule { }
